// node modules
import Vivus from 'vivus';

// constants
import { SELECTORS } from '@/scripts/constants';

// other
import { controller } from '@/scrollmagic/controller';

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-animation="section"]').forEach((section) => {
    const scene = new ScrollMagic.Scene({
      triggerHook: 'onEnter',
      triggerElement: section,
      offset: 100,
    })
      .on('enter', () => {
        section.classList.add(SELECTORS.animated);
      });
    scene.addTo(controller);
  });

  document.querySelectorAll('[data-role="draw-svg"]')
    .forEach((container) => {
      const svg = container.querySelector('svg');
      return new Vivus(svg, {
        duration: container.dataset.duration || 300,
        start: 'inViewport',
      });
    });
});
